// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

// GSAP Animation Controllers
import CardHoverController from "./card_hover_controller"
application.register("card-hover", CardHoverController)

import PricingHighlightController from "./pricing_highlight_controller"
application.register("pricing-highlight", PricingHighlightController)

import HeroController from "./hero_controller"
application.register("hero", HeroController)

import ParallaxController from "./parallax_controller"
application.register("parallax", ParallaxController)

import ScrollRevealController from "./scroll_reveal_controller"
application.register("scroll-reveal", ScrollRevealController)

import SmoothScrollController from "./smooth_scroll_controller"
application.register("smooth-scroll", SmoothScrollController)

import StaggerController from "./stagger_controller"
application.register("stagger", StaggerController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import MobileCtaController from "./mobile_cta_controller"
application.register("mobile-cta", MobileCtaController)

import BookingController from "./booking_controller"
application.register("booking", BookingController)

import QuickAvailabilityController from "./quick_availability_controller"
application.register("quick-availability", QuickAvailabilityController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import GlitterTrailController from "./glitter_trail_controller"
application.register("glitter-trail", GlitterTrailController)

import MouseGlowController from "./mouse_glow_controller"
application.register("mouse-glow", MouseGlowController)
